import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../../components/Private/Navbar'
import ListSection from '../../../components/Private/ListSection'
import ModalComponent from '../../../components/Private/ModalComponent'

import contestService from '../../../services/contests'
import categorygroupService from '../../../services/categorygroups'
import categoryService from '../../../services/categories'
import tagService from '../../../services/tags'

export default function List() {

  const navigateTo = useNavigate()
  const params = useParams()
  const [parentData, setParentData] = useState({
    id: params.category_id,
    categoryName: '',
    categoryGroup_id: '',
    contest_id: '',
    contestName: '',
    categoryGroupName: '',
  })

  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorModalTitle, setErrorModalTitle] = useState('Error')
  const [errorMessage, setErrorMessage] = useState('')

  const [showAddModal, setShowAddModal] = useState(false)
  const [addModalTitle, setAddModalTitle] = useState('Crear etiqueta')
  const [showEditModal, setShowEditModal] = useState(false)
  const [editModalTitle, setEditModalTitle] = useState('Editar etiqueta')
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteModalTitle, setDeleteModalTitle] = useState('Borrar etiqueta')

  const [listData, setListData] = useState(null)

  const [selectedItemId, setSelectedItemId] = useState(null)

  const [formData, setFormData] = useState({
    category_id: params.category_id,
    tagName: ''
  })

  const handleFieldChange = (event) => {
    setFormData(
      {
        ...formData,
        [event.target.name]: event.target.value
      }
    )
  }

  useEffect(() => {
  }, [formData])

  const getFormDOM = () => {
    return <>
      <div className='mb-3'>
        <label htmlFor='tagName' className='form-label'>Nombre de etiqueta</label>
        <input
          name='tagName'
          id='tagName'
          type='text'
          className='form-control'
          placeholder='Nombre de etiqueta'
          value={formData.tagName}
          onChange={
            (event) => {
              handleFieldChange(event)
            }
          }
        />
      </div>
    </>
  }

  const handleDataCreate = async () => {
    try {
      await tagService.create(formData)
      await handleDataLoad()
      setShowAddModal(false)
      setSelectedItemId(null)
    } catch (error) {
      setErrorMessage(error.response.data.messages.error)
      setShowErrorModal(true)
    }
  }

  const handleDataUpdate = async (itemId) => {
    try {
      await tagService.update(itemId, formData)
      await handleDataLoad()
      setShowEditModal(false)
      setSelectedItemId(null)
    } catch (error) {
      setErrorMessage(error.response.data.messages.error)
      setShowErrorModal(true)
    }
  }

  const handleDataDelete = async (itemId) => {
    await tagService.remove(itemId)
    await handleDataLoad()
  }

  const handleDataLoad = async () => {

    const category = await categoryService.get(params.category_id)
    const categoryGroup = await categorygroupService.get(category.categoryGroup_id)
    const contest = await contestService.get(categoryGroup.contest_id)

    setParentData({
      ...parentData,
      categoryName: category.categoryName,
      categoryGroup_id: category.categoryGroup_id,
      contestName: contest.contestName,
      contest_id: contest.id,
      categoryGroupName: categoryGroup.categoryGroupName,
    })

    const result = await tagService.byCategory(params.category_id)
    setListData(result)
  }

  useEffect(() => {
    handleDataLoad()
  }, [])

  return (
    <>
      <Navbar />
      {
        listData &&
        <ListSection
          title={`Etiquetas de ${parentData.categoryName}`}
          hasSearch={true}
          hasYear={false}
          tabs={false}
          backRoute={
            {
              title: 'Volver',
              onClick: () => {
                navigateTo('/categories/' + parentData.categoryGroup_id)
              }
            }
          }
          actions={
            {
              title: 'Crear etiqueta',
              onClick: () => {
                setFormData({
                  ...formData,
                  tagName: '',
                })
                setShowAddModal(true)
              }
            }
          }
          columns={
            [
              {
                title: 'Nombre',
                field: 'tagName',
                type: 'text',
                canBeCopied: true,
                sortable: true,
              },
              {
                title: 'Acciones',
                field: 'actions',
                type: 'actions',
              },
            ]
          }
          rows={
            [
              ...listData.map((item, index) => {
                return {
                  tagName: item.tagName,
                  actions: [
                    {
                      className: 'btn',
                      icon: 'bi bi-pencil',
                      tooltip: 'Editar',
                      onClick: () => {
                        setFormData({
                          ...formData,
                          tagName: item.tagName,
                        })
                        setSelectedItemId(item.id)
                        setEditModalTitle('Editar ' + item.tagName)
                        setShowEditModal(true)
                      }
                    },
                    {
                      className: 'btn',
                      icon: 'bi bi-trash',
                      tooltip: 'Borrar',
                      onClick: () => {
                        setSelectedItemId(item.id)
                        setDeleteModalTitle('Borrar ' + item.tagName)
                        setShowDeleteModal(true)
                      }
                    }
                  ],
                }
              })
            ]
          }
        />
      }
      <ModalComponent
        id='createModal'
        title={addModalTitle}
        show={showAddModal}
        setShow={setShowAddModal}
      >
        {getFormDOM()}
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowAddModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              handleDataCreate()
            }}
          >
            Crear
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='editModal'
        title={editModalTitle}
        show={showEditModal}
        setShow={setShowEditModal}
      >
        {getFormDOM()}
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowEditModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              handleDataUpdate(selectedItemId)
            }}
          >
            Guardar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='deleteModal'
        title={deleteModalTitle}
        show={showDeleteModal}
        setShow={setShowDeleteModal}
      >
        <p>¿Está seguro que desea borrar esta etiqueta?</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => {
              handleDataDelete(selectedItemId)
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Borrar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='errorModal'
        title={errorModalTitle}
        show={showErrorModal}
        setShow={setShowErrorModal}
        headerClass='bg-danger text-white'
        modalSize='modal-lg'
      >
        <p>{errorMessage}</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowErrorModal(false)
              setSelectedItemId(null)
            }}
          >
            Ok
          </button>
        </div>
      </ModalComponent>
    </>
  )
}
